<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-toolbox me-2"></i>Acessórios</h1>
          <p class="page-subtitle" *ngIf="contractNumber">Contrato: {{ contractNumber }} — {{ contractName }}</p>
        </div>
        <app-button
          *appHasPermission="'B2BContracts.Edit'"
          text="Novo acessório"
          color="var(--success-color)"
          height="40px"
          (buttonClick)="openCreate()">
          <i class="fas fa-plus me-2"></i>
        </app-button>
      </div>
    </div>

    <app-b2b-operational-nav *ngIf="contractId" [contractId]="contractId" active="acessorios"></app-b2b-operational-nav>

    <div class="b2b-ops-card">
      <h5 class="mb-3">Catálogo do contrato</h5>
      <div *ngIf="!isLoading && accessories.length === 0" class="b2b-ops-empty">
        <i class="fas fa-toolbox"></i>
        <h3>Nenhum acessório no catálogo</h3>
      </div>
      <app-table
        *ngIf="isLoading || accessories.length > 0"
        [title]="'Catálogo (' + accessories.length + ')'"
        [data]="accessories"
        [columns]="columns"
        [actions]="actions"
        [loading]="isLoading"
        [showSearch]="true"
        (actionClick)="onActionClick($event)">
        <app-button
          table-header-action
          text="Exportar Excel"
          color="var(--success-color)"
          height="36px"
          [disabled]="accessories.length === 0"
          (buttonClick)="exportExcel()">
          <i class="fas fa-file-excel me-2"></i>
        </app-button>
      </app-table>
    </div>

    <div class="b2b-ops-card">
      <h5 class="mb-3">Vínculo com pedido</h5>
      <div class="b2b-ops-filters">
        <div class="form-group" style="min-width: 240px;">
          <label class="form-label">Pedido (item)</label>
          <select class="form-select" [(ngModel)]="selectedItemId" (ngModelChange)="onItemChange()">
            <option [ngValue]="null">Selecione um pedido</option>
            <option *ngFor="let it of contractItems" [ngValue]="it.id">{{ it.label }}</option>
          </select>
        </div>
      </div>

      <form *ngIf="selectedItemId" [formGroup]="linkForm" class="b2b-ops-form-grid mb-3" (ngSubmit)="linkAccessory()">
        <div class="form-group">
          <label class="form-label">Acessório *</label>
          <select class="form-select" formControlName="b2bAccessoryId">
            <option [ngValue]="null">Selecione</option>
            <option *ngFor="let a of accessories" [ngValue]="a.id">{{ a.code ? a.code + ' — ' : '' }}{{ a.name }}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">Quantidade *</label>
          <input type="number" class="form-control" formControlName="quantity" min="1">
        </div>
        <div class="form-group full">
          <label class="form-label">Observações</label>
          <input type="text" class="form-control" formControlName="notes">
        </div>
        <div class="form-group full">
          <app-button
            *appHasPermission="'B2BContracts.Edit'"
            text="Vincular ao pedido"
            color="var(--success-color)"
            height="40px"
            type="submit"
            [disabled]="linking">
            <i class="fas fa-link me-2"></i>
          </app-button>
        </div>
      </form>
      <div *ngIf="selectedItemId && !isLoadingLinks && itemAccessories.length === 0" class="text-muted">
        Nenhum acessório vinculado a este pedido.
      </div>
      <app-table
        *ngIf="selectedItemId && (isLoadingLinks || itemAccessories.length > 0)"
        [title]="'Acessórios do pedido'"
        [data]="itemAccessories"
        [columns]="linkColumns"
        [actions]="linkActions"
        [loading]="isLoadingLinks"
        [showSearch]="false"
        (actionClick)="onLinkActionClick($event)">
        <app-button
          table-header-action
          text="Exportar Excel"
          color="var(--success-color)"
          height="36px"
          [disabled]="itemAccessories.length === 0"
          (buttonClick)="exportLinksExcel()">
          <i class="fas fa-file-excel me-2"></i>
        </app-button>
      </app-table>
    </div>
  </div>

  <app-modal [isOpen]="showModal" [title]="modalTitle" size="md" (close)="closeModal()">
    <form [formGroup]="form" class="b2b-ops-form-grid">
      <div class="form-group">
        <label class="form-label">Código</label>
        <input type="text" class="form-control" formControlName="code">
      </div>
      <div class="form-group">
        <label class="form-label">Valor unitário</label>
        <input type="number" class="form-control" formControlName="unitValue" step="0.01">
      </div>
      <div class="form-group full">
        <label class="form-label">Nome *</label>
        <input type="text" class="form-control" formControlName="name">
      </div>
      <div class="form-group full">
        <label class="form-label">Descrição</label>
        <textarea class="form-control" rows="2" formControlName="description"></textarea>
      </div>
      <div class="form-group full">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="accActive" formControlName="isActive">
          <label class="form-check-label" for="accActive">Ativo</label>
        </div>
      </div>
    </form>
    <div slot="footer" class="b2b-ops-modal-footer d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="submitting">
        {{ viewMode ? 'Fechar' : 'Cancelar' }}
      </button>
      <button *ngIf="!viewMode" type="button" class="btn btn-primary" (click)="submit()" [disabled]="submitting">
        {{ editingId ? 'Salvar' : 'Criar' }}
      </button>
    </div>
  </app-modal>
</app-side-menu>
